{
  "nav": {
    "home": "Home",
    "tutorials": "Tutorials",
    "contact": "Contact us",
    "logout": "Logout",
    "logoAlt": "DinLabel",
    "download": "Download",
    "buy": "Buy",
    "login": "Login",
    "myAccount": "My Account",
    "settings": "Settings",
    "distributorPortal": "Distributor portal"
  },
  "settings": {
    "title": "Settings",
    "language": "Language",
    "languageDescription": "Choose the language used in the app. By default, your browser language is used.",
    "languageBrowser": "Use browser language",
    "languageEnglish": "English",
    "languageSpanish": "Spanish",
    "languageGerman": "German",
    "languageFrench": "French"
  },
  "offline": {
    "title": "Offline",
    "message": "The application cannot connect to the server :( !!"
  },
  "dialogs": {
    "apiError": "API Error",
    "confirmYes": "Yes",
    "cancel": "Cancel",
    "send": "Send"
  },
  "portal": {
    "pageTitle": "Distributor portal",
    "greeting": "Welcome, {{name}}",
    "actions": "Actions",
    "authorized": "Authorized",
    "pending": "Pending approval",
    "buyLicenses": "Buy licenses",
    "pendingApproval": "Your distributor application has not been approved yet - for any questions, you can contact {{email}}. This process should not take more than 2 business days.",
    "distributorInfo": "Information for distributors",
    "loading": "Loading distributor information…",
    "loadError": "Could not load distributor information."
  },
  "licenses": {
    "noneAvailable": "You currently have no licenses available to send.",
    "availableCount": "You have {{count}} licenses available to send.",
    "boughtAndSent": "In total, you have purchased {{bought}} licenses and have sent {{sent}} licenses",
    "statAvailable": "Available to send",
    "statBought": "Purchased",
    "statSent": "Sent",
    "sentHistory": "Licenses sent",
    "activatedYes": "Activated",
    "buyTitle": "Distributor Portal - Buy licenses",
    "buyLoading": "Loading…",
    "buyLoadError": "Could not load distributor information.",
    "buyIntro": "Specify how many licenses you want to buy - the distributor price is {{price}} pesos. Distributors can sell DinLabel however they consider appropriate, but our recommended price is {{recommended}} pesos.",
    "licenseCountLabel": "Number of licenses",
    "costSummary": "The cost of {{count}} licenses is {{cost}} pesos + taxes.",
    "buyButton": "Buy {{count}} licenses",
    "sendTitle": "Send license",
    "resendConfirm": "Do you want to resend the license to {{email}}?",
    "sendPrompt": "Enter the email you want to send to",
    "emailPlaceholder": "email@example.com",
    "errorTitle": "Error!",
    "sendError": "There was an error sending the license {{error}}",
    "resentTitle": "License resent!",
    "resentMessage": "The license has been resent to {{email}} with a copy to {{cc}}",
    "sentTitle": "License sent!",
    "sentMessage": "The license has been sent to {{email}} with a copy to {{cc}}",
    "sendToEmail": "Send license to email...",
    "recipient": "License recipient",
    "date": "Date",
    "sent": "Sent",
    "activated": "Activated",
    "notActivated": "Not yet activated",
    "resend": "Resend license"
  },
  "register": {
    "title": "Become a distributor",
    "intro": "To access the DinLabel distributor portal, you must first register:",
    "company": "Company",
    "companyPlaceholder": "Company name",
    "phone": "Phone",
    "phonePlaceholder": "Phone",
    "phoneDescription": "Make sure to include your country code, for example +52 8183...",
    "street": "Street",
    "street1Placeholder": "Street 1",
    "street2Placeholder": "Street 2",
    "number": "Number",
    "city": "City",
    "state": "State",
    "country": "Country",
    "zip": "ZIP code",
    "rfc": "Tax ID (RFC)",
    "nextSteps": "You will receive an email with the next steps",
    "submit": "Submit"
  },
  "faq": {
    "qGoogleAccount": "Do I need a Google account to be a DINLabel distributor?",
    "aGoogleAccount": "Yes, you need a Google account. If you already have one, you can use it to sign in to the distributor portal.",
    "qRequirements": "What do I need to become a DINLabel distributor?",
    "aRequirementsBefore": "Register as a distributor in the",
    "aRequirementsLink": "distributor portal",
    "aRequirementsAfter": "and wait to receive the confirmation email authorizing you as a DINLabel distributor.",
    "qAnyoneCanSell": "Can any person or company sell DINLabel?",
    "aAnyoneCanSell": "Yes, you only need to register in the DINLabel distributor portal and receive the confirmation email.",
    "qHowManyDistributors": "How many distributors can there be in DINLabel?",
    "aHowManyDistributors": "There is no limit.",
    "qDistributorCost": "How much does a DINLabel license cost a distributor?",
    "aDistributorCost": "112 USD plus taxes per license.",
    "qRecommendedPrice": "What is the recommended retail price from the distributor to their customers for a DINLabel license?",
    "aRecommendedPrice": "The distributor sets the price; there is no fixed price. We suggest a selling price of 160 USD plus taxes. The direct price on the DINLabel portal without a distributor is 180 USD.",
    "qWhereToBuy": "Where can an end user buy a DINLabel license?",
    "aWhereToBuyBefore": "They can buy it from a distributor or directly on the portal",
    "qHowBuyAsDistributor": "As a distributor, how do I buy DINLabel licenses?",
    "aHowBuyAsDistributorBefore": "Through the Distributor Portal, by going to the Buy Licenses section. See the tutorial",
    "aHowBuyAsDistributorLink": "how to buy licenses.",
    "qMinimumLicenses": "As a distributor, when buying licenses to later sell to my customers, what is the minimum number of licenses I must buy?",
    "aMinimumLicenses": "There is no minimum; you can buy from 1 license.",
    "qHowDeliver": "As a distributor, how do I deliver a DINLabel license to my customer?",
    "aHowDeliverBefore": "Through the distributor portal, in the",
    "aHowDeliverSendLink": "send licenses",
    "aHowDeliverMiddle": " section; see the",
    "aHowDeliverTutorialLink": "tutorial on how to send licenses.",
    "qHowLongPurchase": "How long does it take to buy a license as a distributor and deliver it to the customer?",
    "aHowLongPurchase": "If you are already registered as a distributor, the purchase and license delivery can be done in minutes.",
    "qHowLongToSell": "As a distributor, how long do I have to sell the licenses I purchase in the portal?",
    "aHowLongToSell": "Distributor licenses do not expire. When you buy licenses they are added to your license inventory and you can use them at any time.",
    "qHowManyAvailable": "How can I tell how many licenses I have as a distributor?",
    "aHowManyAvailableBefore": "When you enter the DINLabel",
    "aHowManyAvailableLink": "distributor portal",
    "aHowManyAvailableAfter": ", the first screen shows your balance of licenses available to send.",
    "qSoldLicenses": "How can I tell which licenses I have sold and to whom?",
    "aSoldLicensesBefore": "Through the DINLabel distributor portal in the",
    "aSoldLicensesLink": "view details",
    "qTryBefore": "Can I try DINLabel before becoming a distributor?",
    "aTryBeforeBefore": "Yes, you can download a Demo at",
    "aTryBeforeAfter": "and try it.",
    "qMainFaq": "Are there FAQs (frequently asked questions) on the DINLabel portal?",
    "aMainFaqBefore": "At",
    "aMainFaqAfter": "you will find the most frequent questions about using the DINLabel system.",
    "qTutorials": "Are there tutorials for using DINLabel?",
    "aTutorialsBefore": "At",
    "aTutorialsAfter": "you will find all the tutorials needed to use DINLabel.",
    "qSupport": "As a distributor, do I have technical support?",
    "aSupport": "By email; see the end of this FAQ.",
    "qOtherQuestion": "I have a question that is not on the list. What can I do?",
    "aOtherQuestionBefore": "We would love to help. Go to",
    "aOtherQuestionLink": "contact us",
    "aOtherQuestionAfter": ", send your questions, and we will gladly respond."
  },
  "tutorials": {
    "title": "Tutorials",
    "alsoSeeFaqBefore": "You can also see the",
    "alsoSeeFaqLink": "FAQ",
    "sendLicenseTutorial": "Tutorial: How to send a license from the distributor portal",
    "iframeTitle": "Send license tutorial"
  },
  "home": {
    "welcome": "Welcome, {{name}}",
    "error": "Error"
  },
  "buy": {
    "welcome": "Welcome, {{name}}"
  },
  "userLicenses": {
    "hasLicense": "You already have a DinLabel license.",
    "noLicense": "You have not purchased your DinLabel license",
    "buyHere": "Purchase it here"
  },
  "app": {
    "documentTitle": "DinLabel"
  },
  "signin": {
    "title": "Sign in",
    "intro": "Sign in with your Google account to continue.",
    "withGoogle": "Sign in with Google",
    "agreePrefix": "By continuing you agree to our",
    "privacyLink": "Privacy Policy and Terms of Service",
    "alreadySignedIn": "You are already signed in",
    "signedInAs": "Signed in as {{email}}",
    "continue": "Continue",
    "debugSignInUrl": "Sign-in URL"
  },
  "marketing": {
    "headline": "Professional label design software",
    "slogan": "Design, print, and manage labels with barcodes, variable data, and more.",
    "featureNumbers": "Numbers in series",
    "featureImages": "Images",
    "featureVariable": "Variable data",
    "featureQr": "2D barcode",
    "featureText": "Text",
    "featureBarcode": "Barcode",
    "featuresTitle": "Everything you need on a label",
    "featuresSubtitle": "Build professional labels with the tools print shops and warehouses rely on every day.",
    "whyTitle": "Why DinLabel?",
    "whyBody": "DinLabel helps you create professional labels quickly for rolls, sheets, and industrial printers.",
    "tryTitle": "Try the DinLabel demo",
    "trySubtitle": "Download the demo version and start designing labels in minutes.",
    "needHelp": "Need help?",
    "customerService": "Customer service",
    "customerServiceText": "Contact us by email and we will gladly help.",
    "tutorialsText": "Step-by-step video tutorials for every feature."
  },
  "footer": {
    "tagline": "Professional label design for rolls, sheets, and industrial printers.",
    "privacy": "Privacy & terms",
    "copyright": "© {{year}} DinLabel"
  },
  "install": {
    "title": "Download",
    "intro": "Install DinLabel on Windows and start designing professional labels in minutes.",
    "windowsNote": "Windows installer (.exe). Works on Windows 7 and newer.",
    "requirements": "System requirements",
    "reqWindows": "Any Windows version after (Windows 7 and newer)",
    "reqInternet": "Internet access",
    "reqRam": "1 GB RAM",
    "reqDisk": "10 GB Hard disk storage",
    "freeTag": "Demo version",
    "freeText": "The demo version includes a watermark on printed labels.",
    "paidTitle": "Full version",
    "paidText": "No watermarks — ready for production printing.",
    "buyApp": "Buy the application",
    "orDistributor": "Prefer to buy through a partner?",
    "distributorsLink": "View distributors"
  },
  "fullTutorials": {
    "title": "Tutorials",
    "intro": "Step-by-step videos to help you design, print, and get the most out of DinLabel.",
    "howToRoll": "How to create a label on a roll",
    "howToSheet": "How to create a label on a sheet",
    "howTo3Across": "How to create 3-across labels",
    "howToText": "How to add text",
    "howToShapes": "How to add shapes",
    "howToImages": "How to add images",
    "howToBarCodes": "How to add barcodes",
    "howToQR": "How to add QR codes",
    "howToPrint": "How to print",
    "howToConsecutive": "How to use consecutive numbers",
    "howToDataBase": "How to use databases",
    "howToBuy": "How to buy DinLabel",
    "alsoDistributor": "Distributor-specific tutorials are available in the distributor portal.",
    "distributorLink": "Open distributor portal"
  },
  "privacy": {
    "title": "Privacy Policy and Terms of Service",
    "eulaLink": "End User License Agreement",
    "policyLink": "Privacy Policy",
    "note": "The privacy policy opens the localized static HTML document.",
    "loading": "Loading…",
    "eulaLoadError": "Could not load the EULA."
  },
  "distributors": {
    "title": "Distributors"
  },
  "buyPage": {
    "title": "Buy DinLabel",
    "intro": "Unlock the full version — no watermarks, ready for production printing.",
    "panelTitle": "Full version license",
    "loading": "Loading checkout…",
    "loadError": "Could not start checkout. Please sign in and try again.",
    "errorTitle": "Something went wrong",
    "thanks": "You have the full version of DinLabel!",
    "checkAccount": "Check the status of your account",
    "price": "USD ${{price}} + Tax",
    "payWithCard": "Pay with card",
    "payError": "Could not redirect to Stripe checkout.",
    "orVia": "Prefer another option?",
    "downloadDemo": "Download a fully working demo",
    "contactDistributor": "Contact a distributor",
    "becomeDistributor": "Want to become a distributor?"
  },
  "userInfo": {
    "title": "My Account",
    "detailsTitle": "Account details",
    "quickLinks": "Quick links",
    "userId": "User ID",
    "name": "Your name",
    "email": "Email address",
    "emailConfirmed": "Email confirmed",
    "confirmed": "Confirmed",
    "notConfirmed": "Not confirmed",
    "resend": "Resend",
    "resentEmail": "Confirmation email resent to {{email}}",
    "resendError": "Could not resend confirmation email.",
    "version": "Application version",
    "freeVersion": "Demo version",
    "fullVersion": "Full version",
    "buyApp": "Buy the application",
    "accountType": "Account",
    "admin": "Admin portal",
    "openDistributorPortal": "Open distributor portal"
  },
  "myLabels": {
    "title": "My Labels",
    "loading": "Loading…",
    "loadError": "Could not load labels.",
    "empty": "You have no saved labels.",
    "name": "Name",
    "date": "Date",
    "view": "View",
    "download": "Download",
    "back": "Back to my labels"
  },
  "admin": {
    "title": "Admin Portal",
    "dataLink": "Data tools",
    "fakeEmailLink": "Fake emails",
    "loading": "Loading…",
    "loadError": "Could not load admin data.",
    "totalUsers": "Total users: {{count}}",
    "paidUsers": "Paid users: {{count}}",
    "users": "Users",
    "distributors": "Distributors",
    "payments": "Distributor payments",
    "authorize": "Authorize"
  },
  "fakeEmail": {
    "title": "Fake emails",
    "description": "Preview generated email templates with placeholder data.",
    "distributorSignUp": "Distributor sign-up",
    "activationLink": "Activation / confirm email",
    "sendEmailLicense": "Distributor send license",
    "congratulationEmail": "Congratulations",
    "boughtLicensesMail": "Bought licenses",
    "subject": "Subject",
    "body": "Body",
    "loading": "Loading…",
    "loadError": "Could not load this email.",
    "backAdmin": "Back to admin"
  }
}
